import React from 'react';
import EmojiListItem from './emoji-list-item';

const EmojiListGrid = ({ data }) => {
    return (
        <div className='emoji-list-grid'>
            {data.items.map(emojiListItem => (
                <EmojiListItem data={emojiListItem} />
            ))}
        </div>
    )
}
export default EmojiListGrid